import { render, staticRenderFns } from "./TheBanner.vue?vue&type=template&id=1582a033&scoped=true&"
import script from "./TheBanner.vue?vue&type=script&lang=js&"
export * from "./TheBanner.vue?vue&type=script&lang=js&"
import style0 from "./TheBanner.vue?vue&type=style&index=0&id=1582a033&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1582a033",
  null
  
)

export default component.exports